// API Configuration for different environments.
//
// VITE_API_URL is set per-environment in the Vercel dashboard (baked at build
// time by Vite). It MUST be non-empty for Preview: an empty value is falsy and
// silently falls through to the production domain below, so a `dev` preview
// would talk to prod. Preview scope -> dev API Gateway stage; Production
// scope -> api.symbioflows.com custom domain.
const getApiUrl = () => {
  // Explicit API URL override from environment variable
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }

  // Use production domain for production builds
  if (import.meta.env.PROD || import.meta.env.MODE === 'production') {
    // Production: Use Custom Domain
    return 'https://api.symbioflows.com';
  }

  // Use localhost for local development
  return 'http://localhost:3300';
};

export const API_CONFIG = {
  BASE_URL: getApiUrl(),
  ENDPOINTS: {
    GENERATE_REPORT: '/api/reports/generate-valorization',
    GET_REPORT: '/api/reports',
    DOWNLOAD_PDF: '/api/reports/download-pdf',
    HEALTH: '/health',
    HEALTH_DETAILED: '/api/health/detailed'
  },
  HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
};

export default API_CONFIG;
